import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

function Error404Page() {
  return (
    <div className="flex flex-col flex-1 items-center justify-center p-16">
      <div className="max-w-512 text-center">
        <Typography variant="h2" color="inherit" className="font-medium mb-16">
          Page not found
        </Typography>
        <Typography variant="h5" color="textSecondary" className="mb-16 font-normal">
          Sorry but we could not find the page you are looking for
        </Typography>
        <Link className="font-normal" to="/">
          Go back to home
        </Link>
      </div>
    </div>
  );
}

export default Error404Page;
